// src/components/sidebar/sidebar-nav.jsx
import React from 'react';
import { NavLink, useResolvedPath, useMatch, useLocation, matchPath } from 'react-router-dom';
import menus from './../../config/app-menu.jsx';
import { Card, CardHeader } from '../card/card.jsx';

function NavItem({ menu, ...props }) {
  let path = menu.path || '';
  let resolved = useResolvedPath(path);
  let match = useMatch({ path: resolved.pathname });
  let location = useLocation();
  
  if (menu.is_header) {
    return <div className="menu-header">{ menu.title }</div>;
  }
  
  if (menu.is_divider) {
    return <div className="menu-divider"></div>;
  }
  
  let match2 = matchPath({ path: path, end: false }, location.pathname);

  let icon   = menu.icon && <div className="menu-icon"><i className={menu.icon}></i></div>;
  let img    = menu.img && <div className="menu-icon-img"><img src={menu.img} alt="" /></div>;
  let caret  = (menu.children && !menu.badge) && <div className="menu-caret"><b className="caret"></b></div>;
  let label  = menu.label && <span className="menu-label ms-5px">{menu.label}</span>;
  let badge  = menu.badge && <div className="menu-badge">{menu.badge}</div>;
  let highlight = menu.highlight && <i className="fa fa-paper-plane text-theme"></i>;
  let title  = menu.title && <div className="menu-text">{menu.title} {label} {highlight}</div>;
  
  return (
    <div className={
      'menu-item' + ((match || match2) ? ' active' : '') + (menu.children ? ' has-sub' : '')
    }>
      <NavLink className="menu-link" to={menu.path} {...props}>
        { img } { icon } { title } { caret } { badge }
      </NavLink>
    
      {menu.children && (
        <div className="menu-submenu">
          {menu.children.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

function SidebarNav() {
  // Get the current role from localStorage
  const role = localStorage.getItem("role");

  // Filter out any menu items that are marked as adminOnly when the user is not an admin.
  // (If your menu structure has nested children, you might want to apply this recursively.)
  const filteredMenus = menus.filter(menu => {
    if (menu.adminOnly && role !== 'admin') {
      return false;
    }
    return true;
  });

  return (
    <div className="menu">
      {filteredMenus.map((menu, i) => (
        <NavItem key={i} menu={menu} />
      ))}
      <Card className="mt-4" style={{ margin: "12px" }}>
        <CardHeader>
          Keyboard Shortcuts
        </CardHeader>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Key</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Arrow <i className="fas fa-arrow-right" /></td>
              <td>Next Item</td>
            </tr>
            <tr>
              <td>Arrow <i className="fas fa-arrow-left" /></td>
              <td>Previous Item</td>
            </tr>
          </tbody>
        </table>
      </Card>
    </div>
  );
}

export default SidebarNav;
